import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import ax from "./auth/axios";
import { API_ROOT, API_ROOT1 } from "./utils/api-config";
import { connect } from "react-redux";
import { editMerchantProfile } from "../actions/merchantAction";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Navbar from "react-bootstrap/Navbar";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { hours } from "./files";
import SweetAlert from "react-bootstrap-sweetalert";

class EditMerchantProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      merchantName: "",
      postal_code: "",
      city: "",
      province: "",
      country: "Canada",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      website: "",
      address: "",
      store_hours: {
        1: {
          Open: "",
          Close: "",
        },
        2: {
          Open: "",
          Close: "",
        },
        3: {
          Open: "",
          Close: "",
        },
        4: {
          Open: "",
          Close: "",
        },
        5: {
          Open: "",
          Close: "",
        },
        6: {
          Open: "",
          Close: "",
        },
        0: {
          Open: "",
          Close: "",
        },
      },
      default_security: "",
      pricepoint: "",
      parent_organization: "",
      zone: "",
      vertical: "",
      free_shipping_threshold: 0,
      shipping_cost_if_not_free: 0,
      delivery_title: "",
      delivery_description: "",
      additional_standard_item_price: 0,
      merchant_price: 0,
      exchange_price: 0,
      additional_overweight_item_price: 0,
      advanced_plan: false,
      local_delivery: false,
      text_alerts_on: false,
      text_alerts_phone_number: "",
      inzone_order_alert: false,
      delivery_alerts: false,
      delivery_alert_email: "",
      inzone_order_alert_email1: "",
      inzone_order_alert_email2: "",
      delivery_booked_alert: "",
      delivery_booked_email: "",
      pick_up_notes: "",
      weight_threshold: 0,
      overweight_order_price: 0,
      shopify_store: false,
      payment_terms: "",
      payment_days: 0,
      billing_email: "",
      billing_contact: "",
      allowed_fsas: {},
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    // this.handleCheckSubmit = this.handleCheckSubmit.bind(this);
    // this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateHours = this.updateHours.bind(this);
  }

  componentDidMount() {
    const { merchant } = this.props;

    this.setState({
      merchantName: merchant.name,
      postal_code: merchant.postal_code,
      city: merchant.city,
      province: merchant.province,
      country: "Canada",
      contact_name: merchant.contact_name,
      contact_email: merchant.contact_email,
      contact_phone: merchant.contact_phone,
      website: merchant.website,
      address: merchant.address,
      store_hours: {
        1: {
          Open: merchant.store_hours[1].Open,
          Close: merchant.store_hours[1].Close,
        },
        2: {
          Open: merchant.store_hours[2].Open,
          Close: merchant.store_hours[2].Close,
        },
        3: {
          Open: merchant.store_hours[3].Open,
          Close: merchant.store_hours[3].Close,
        },
        4: {
          Open: merchant.store_hours[4].Open,
          Close: merchant.store_hours[4].Close,
        },
        5: {
          Open: merchant.store_hours[5].Open,
          Close: merchant.store_hours[5].Close,
        },
        6: {
          Open: merchant.store_hours[6].Open,
          Close: merchant.store_hours[6].Close,
        },
        0: {
          Open: merchant.store_hours[0].Open,
          Close: merchant.store_hours[0].Close,
        },
      },
      default_security: merchant.default_security,
      pricepoint: merchant.pricepoint,
      parent_organization: merchant.parent_organization,
      zone: merchant.zone,
      vertical: merchant.vertical,
      delivery_title: merchant.delivery_title,
      delivery_description: merchant.delivery_description,
      text_alerts_on: merchant.text_alerts_on ? merchant.text_alerts_on : false,
      text_alerts_phone_number: merchant.text_alerts_phone_number,
      additional_standard_item_price: merchant.additional_standard_item_price,
      exchange_price: merchant.exchange_price,
      merchant_price: merchant.merchant_price,
      additional_overweight_item_price:
        merchant.additional_overweight_item_price,
      inzone_order_alert: merchant.inzone_order_alert
        ? merchant.inzone_order_alert
        : false,
      delivery_alerts: merchant.delivery_alerts
        ? merchant.delivery_alerts
        : false,
      delivery_alert_email: merchant.delivery_alert_email,
      inzone_order_alert_email1: merchant.inzone_order_alert_email1,
      inzone_order_alert_email2: merchant.inzone_order_alert_email2,
      delivery_booked_alert: merchant.delivery_booked_alert,
      delivery_booked_email: merchant.delivery_booked_email,
      pick_up_notes: merchant.pick_up_notes,
      weight_threshold: merchant.weight_threshold,
      free_shipping_threshold: merchant.free_shipping_threshold,
      shipping_cost_if_not_free: merchant.shipping_cost_if_not_free,
      overweight_order_price: merchant.overweight_order_price,
      shopify_store: merchant.shopify_store ? merchant.shopify_store : false,
      advanced_plan: merchant.advanced_plan ? merchant.advanced_plan : false,
      local_delivery: merchant.local_delivery ? merchant.local_delivery : false,
      payment_terms: merchant.payment_terms,
      payment_days: merchant.payment_days,
      billing_contact: merchant.billing_contact,
      billing_email: merchant.billing_email,
      allowed_fsas: merchant.allowed_fsas,
    });
  }
  showAlert = (message) => {
    this.setState({
      showSuccess: true,
      message: message,
    });
  };
  getLocationId = () => {
    const formData = new FormData();
    formData.append("merchant_id", this.props.merchant.id);

    ax.post(`${API_ROOT1}/merchants/get_location_id`, formData)
      .then((response) => this.showAlert(response.data))
      .then(() => this.props.refresh())
      .catch((error) => console.log("api errors:", error));
  };

  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    formData.append("merchant[name]", this.state.merchantName);
    formData.append("merchant[website]", this.state.website);
    this.state.default_security &&
      formData.append("merchant[default_security]", this.state.default_security);
    this.state.pricepoint &&
      formData.append("merchant[pricepoint]", this.state.pricepoint);
    this.state.parent_organization &&
      formData.append(
        "merchant[parent_organization]",
        this.state.parent_organization
      );
    this.state.zone && formData.append("merchant[zone]", this.state.zone);
    this.state.vertical &&
      formData.append("merchant[vertical]", this.state.vertical);
    this.state.address &&
      formData.append("merchant[address]", this.state.address);
    this.state.city && formData.append("merchant[city]", this.state.city);
    this.state.province &&
      formData.append("merchant[province]", this.state.province);
    this.state.postal_code &&
      formData.append("merchant[postal_code]", this.state.postal_code);
    this.state.contact_name &&
      formData.append("merchant[contact_name]", this.state.contact_name);
    this.state.contact_email &&
      formData.append("merchant[contact_email]", this.state.contact_email);
    this.state.contact_phone &&
      formData.append("merchant[contact_phone]", this.state.contact_phone);
    formData.append("merchant[text_alerts_on]", this.state.text_alerts_on);
    this.state.text_alerts_phone_number &&
      formData.append(
        "merchant[text_alerts_phone_number]",
        this.state.text_alerts_phone_number
      );
    formData.append(
      "merchant[store_hours[1][Open]]",
      this.state.store_hours[1].Open
    );
    formData.append(
      "merchant[store_hours[1][Close]]",
      this.state.store_hours[1].Close
    );
    formData.append(
      "merchant[store_hours[2][Open]]",
      this.state.store_hours[2].Open
    );
    formData.append(
      "merchant[store_hours[2][Close]]",
      this.state.store_hours[2].Close
    );
    formData.append(
      "merchant[store_hours[3][Open]]",
      this.state.store_hours[3].Open
    );
    formData.append(
      "merchant[store_hours[3][Close]]",
      this.state.store_hours[3].Close
    );
    formData.append(
      "merchant[store_hours[4][Open]]",
      this.state.store_hours[4].Open
    );
    formData.append(
      "merchant[store_hours[4][Close]]",
      this.state.store_hours[4].Close
    );
    formData.append(
      "merchant[store_hours[5][Open]]",
      this.state.store_hours[5].Open
    );
    formData.append(
      "merchant[store_hours[5][Close]]",
      this.state.store_hours[5].Close
    );
    formData.append(
      "merchant[store_hours[6][Open]]",
      this.state.store_hours[6].Open
    );
    formData.append(
      "merchant[store_hours[6][Close]]",
      this.state.store_hours[6].Close
    );
    formData.append(
      "merchant[store_hours[0][Open]]",
      this.state.store_hours[0].Open
    );
    formData.append(
      "merchant[store_hours[0][Close]]",
      this.state.store_hours[0].Close
    );
    this.state.additional_standard_item_price &&
      formData.append(
        "merchant[additional_standard_item_price]",
        this.state.additional_standard_item_price
      );
    this.state.merchant_price &&
      formData.append("merchant[merchant_price]", this.state.merchant_price);
    this.state.exchange_price &&
      formData.append("merchant[exchange_price]", this.state.exchange_price);
    this.state.additional_overweight_item_price &&
      formData.append(
        "merchant[additional_overweight_item_price]",
        this.state.additional_overweight_item_price
      );
    this.state.text_alerts_on &&
      formData.append("merchant[text_alerts_on]", this.state.text_alerts_on);
    this.state.text_alerts_phone_number &&
      formData.append(
        "merchant[text_alerts_phone_number]",
        this.state.text_alerts_phone_number
      );
    formData.append(
      "merchant[inzone_order_alert]",
      this.state.inzone_order_alert
    );
    formData.append("merchant[delivery_alerts]", this.state.delivery_alerts);
    this.state.delivery_alert_email &&
      formData.append(
        "merchant[delivery_alert_email]",
        this.state.delivery_alert_email
      );
    this.state.inzone_order_alert_email1 &&
      formData.append(
        "merchant[inzone_order_alert_email1]",
        this.state.inzone_order_alert_email1
      );
    this.state.inzone_order_alert_email2 &&
      formData.append(
        "merchant[inzone_order_alert_email2]",
        this.state.inzone_order_alert_email2
      );
    this.state.delivery_booked_alert &&
      formData.append(
        "merchant[delivery_booked_alert]",
        this.state.delivery_booked_alert
      );
    this.state.delivery_booked_email &&
      formData.append(
        "merchant[delivery_booked_email]",
        this.state.delivery_booked_email
      );
    this.state.customer_support_email &&
      formData.append(
        "merchant[customer_support_email]",
        this.state.customer_support_email
      );
    this.state.weight_threshold &&
      formData.append(
        "merchant[weight_threshold]",
        this.state.weight_threshold
      );
    this.state.free_shipping_threshold &&
      formData.append(
        "merchant[free_shipping_threshold]",
        this.state.free_shipping_threshold
      );
    this.state.shipping_cost_if_not_free &&
      formData.append(
        "merchant[shipping_cost_if_not_free]",
        this.state.shipping_cost_if_not_free
      );
    this.state.overweight_order_price &&
      formData.append(
        "merchant[overweight_order_price]",
        this.state.overweight_order_price
      );
    this.state.pick_up_notes &&
      formData.append("merchant[pick_up_notes]", this.state.pick_up_notes);
    this.state.delivery_title &&
      formData.append("merchant[delivery_title]", this.state.delivery_title);
    this.state.delivery_description &&
      formData.append(
        "merchant[delivery_description]",
        this.state.delivery_description
      );
    formData.append("merchant[shopify_store]", this.state.shopify_store);
    formData.append("merchant[advanced_plan]", this.state.advanced_plan);
    formData.append("merchant[local_delivery]", this.state.local_delivery);
    this.state.payment_terms &&
      formData.append("merchant[payment_terms]", this.state.payment_terms);
    this.state.payment_days &&
      formData.append(
        "merchant[payment_days]",
        parseInt(this.state.payment_days)
      );
    this.state.billing_contact &&
      formData.append("merchant[billing_contact]", this.state.billing_contact);
    this.state.billing_email &&
      formData.append("merchant[billing_email]", this.state.billing_email);
    this.state.allowed_fsas &&
      formData.append(
        "merchant[allowed_fsas]",
        "," + this.state.allowed_fsas + ","
      );

    ax.patch(
      `${API_ROOT}/merchants/${this.props.match.params.id}`,
      formData,
      config
    )
      .then((response) => {
        this.props.editMerchantProfile(response.data);
      })
      .then(() => this.props.refresh());
    this.props.show();
    // .catch(error => console.log("api errors:", error));
    // .then(response => {
    //   console.log(JSON.stringify(response.data))
    // })
  }
  // redirect = () => {
  //   this.props.history.push({ pathname: "/trackers" });
  // };
  // handleCheckSubmit(event) {
  //   event.preventDefault();
  //   const value = this.state.fsa;
  //   this.toggleVisible();
  //   this.showAlert(value.slice(0, 3).toUpperCase());
  // }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  updateHours(inputName) {
    return (event) => {
      event.preventDefault();
      const newValue = event.target.value;
      const name = event.target.name;

      this.setState((prevState) => {
        return {
          store_hours: {
            ...prevState.store_hours,
            [inputName]: {
              ...prevState.store_hours[inputName],
              [name]: newValue,
            },
          },
        };
      });
    };
  }
  createOptions = () =>
    hours.map((hour, i) => (
      <option key={i} value={i}>
        {hours[i]}
      </option>
    ));
  render() {
    // const { merchant } = this.props.merchant;
    const week = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return (
      <div className="container-fluid">
        <Fragment>
          <style type="text/css">
            {`
    .btn-flat {
      display: inline;
      background-color: #184667;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #eca3a359;
      color: #af0707;
      border-radius: 8px;
      border: 1px solid teal;  
    }
    `}
          </style>
          <Navbar
            bg="danger"
            variant="light"
            className="justify-content-between"
          >
            <Navbar.Brand>
              Edit Merchant Profile of {this.state.merchantName}
            </Navbar.Brand>
            <Button onClick={this.getLocationId} variant="primary">
              Get Location Id
            </Button>
          </Navbar>
          <Form className="bg-flat" onSubmit={this.handleSubmit}>
            <br></br>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridMerchant">
                <Form.Label>Merchant Name</Form.Label>
                <Form.Control
                  name="merchantName"
                  value={this.state.merchantName}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridWebsite">
                <Form.Label>Merchant Website</Form.Label>
                <Form.Control
                  name="website"
                  value={this.state.website}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
              <Col sm="2">
                <Form.Group>
                  <Form.Label>Shopify Store</Form.Label>
                  <Form.Check
                    name="shopify_store"
                    checked={this.state.shopify_store}
                    onChange={this.handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col sm="2">
                <Form.Group>
                  <Form.Label>Advanced Plan</Form.Label>
                  <Form.Check
                    name="advanced_plan"
                    checked={this.state.advanced_plan}
                    onChange={this.handleInputChange}
                  />
                </Form.Group>
              </Col>
   
              <Form.Group as={Col} controlId="formGridDefaultSecurity">
                <Form.Label>Default Security</Form.Label>
                <Form.Control
                  name="default_security"
                  value={this.state.default_security}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridPricepoint">
                <Form.Label>PricePoint</Form.Label>
                <Form.Control
                  name="pricepoint"
                  value={this.state.pricepoint}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridParent">
                <Form.Label>Parent Organization</Form.Label>
                <Form.Control
                  name="parent_organization"
                  value={this.state.parent_organization}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridZone">
                <Form.Label>Zone</Form.Label>
                <Form.Control
                  name="zone"
                  value={this.state.zone}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridVertical">
                <Form.Label>Vertical</Form.Label>
                <Form.Control
                  name="vertical"
                  value={this.state.vertical}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridContactName">
                <Form.Label>Contact Name</Form.Label>
                <Form.Control
                  name="contact_name"
                  value={this.state.contact_name}
                  onChange={this.handleInputChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formBasicEmail">
                <Form.Label>Contact Email</Form.Label>
                <Form.Control
                  type="email"
                  value={this.state.contact_email}
                  name="contact_email"
                  onChange={this.handleInputChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridPhone">
                <Form.Label>Contact Phone</Form.Label>
                <Form.Control
                  value={this.state.contact_phone}
                  name="contact_phone"
                  onChange={this.handleInputChange}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridAddress">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  value={this.state.address}
                  name="address"
                  onChange={this.handleInputChange}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridCity">
                <Form.Label>City</Form.Label>
                <Form.Control
                  value={this.state.city}
                  name="city"
                  onChange={this.handleInputChange}
                  as="select"
                >
                  <option>Choose...</option>
                  <option>Toronto</option>
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col} controlId="formGridState">
                <Form.Label>Province</Form.Label>
                <Form.Control
                  value={this.state.province}
                  name="province"
                  onChange={this.handleInputChange}
                  as="select"
                >
                  <option>Choose...</option>
                  <option>Ontario</option>
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col} controlId="formGridZip">
                <Form.Label>Postal Code</Form.Label>
                <Form.Control
                  value={this.state.postal_code}
                  name="postal_code"
                  onChange={this.handleInputChange}
                />
              </Form.Group>
            </Form.Row>
            <Accordion>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-danger"
                  eventKey="0"
                >
                  Store Hours
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <Form.Row>
                      {week.map((day, i) => (
                        <Form.Group key={week[i]} as={Col}>
                          <Form.Label>{week[i]}</Form.Label>
                          <Form.Control
                            id={`open${i}`}
                            name="Open"
                            onChange={this.updateHours(i)}
                            value={this.state.store_hours[i].Open}
                            as="select"
                          >
                            <option>Open</option>
                            {this.createOptions()}
                          </Form.Control>
                          <Form.Control
                            id={`close${i}`}
                            name="Close"
                            onChange={this.updateHours(i)}
                            value={this.state.store_hours[i].Close}
                            as="select"
                          >
                            <option>Close</option>
                            {this.createOptions()}
                          </Form.Control>
                        </Form.Group>
                      ))}
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-danger"
                  eventKey="1"
                >
                  Text Alerts
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <Form.Row>
                      <Col sm="3">
                        <Form.Group>
                          <Form.Check
                            label="Receive Text Alerts?"
                            name="text_alerts_on"
                            checked={this.state.text_alerts_on}
                            onChange={this.handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="9">
                        {this.state.text_alerts_on && (
                          <Form.Group
                            as={Form.Row}
                            controlId="formPlainAlertPhone"
                          >
                            <Form.Label column>
                              Phone Number to Receive SMS Updates
                            </Form.Label>
                            <Col>
                              <Form.Control
                                name="text_alerts_phone_number"
                                value={this.state.text_alerts_phone_number}
                                onChange={this.handleInputChange}
                              />
                            </Col>
                          </Form.Group>
                        )}
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      <Col sm="3">
                        <Form.Group>
                          <Form.Check
                            label="Receive Inzone Order Updates?"
                            name="inzone_order_alert"
                            checked={this.state.inzone_order_alert}
                            onChange={this.handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="9">
                        {this.state.inzone_order_alert && (
                          <Form.Group
                            as={Form.Row}
                            controlId="inzone_order_alert_email"
                          >
                            <Form.Label column>
                              Email to Receive Inzone Order Updates
                            </Form.Label>
                            <Col>
                              <Form.Control
                                name="inzone_order_alert_email1"
                                value={this.state.inzone_order_alert_email1}
                                onChange={this.handleInputChange}
                              />
                            </Col>
                          </Form.Group>
                        )}
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      <Col sm="3">
                        <Form.Group>
                          <Form.Check
                            label="Receive Delivery Booked Updates?"
                            name="delivery_booked_alert"
                            checked={this.state.delivery_booked_alert}
                            onChange={this.handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="9">
                        {this.state.delivery_booked_alert && (
                          <Form.Group
                            as={Form.Row}
                            controlId="delivery_booked_email"
                          >
                            <Form.Label column>
                              Email to Receive Delivery Booked Updates
                            </Form.Label>
                            <Col>
                              <Form.Control
                                name="delivery_booked_email"
                                value={this.state.delivery_booked_email}
                                onChange={this.handleInputChange}
                              />
                            </Col>
                          </Form.Group>
                        )}
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      <Col sm="3">
                        <Form.Group>
                          <Form.Check
                            label="Receive Delivery Updates?"
                            name="delivery_alerts"
                            checked={this.state.delivery_alerts}
                            onChange={this.handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="9">
                        {this.state.delivery_alerts && (
                          <Form.Group
                            as={Form.Row}
                            controlId="delivery_alert_email"
                          >
                            <Form.Label column>
                              Email to Receive Delivery Updates
                            </Form.Label>
                            <Col>
                              <Form.Control
                                name="delivery_alert_email"
                                value={this.state.delivery_alert_email}
                                onChange={this.handleInputChange}
                              />
                            </Col>
                          </Form.Group>
                        )}
                      </Col>
                    </Form.Row>
                    <Form.Row>
                      <Col sm="3">
                        <Form.Group>
                          <Form.Check
                            label="Receive Requests from Customers?"
                            name="customer_support"
                            checked={this.state.customer_support}
                            onChange={this.handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="9">
                        {this.state.customer_support && (
                          <Form.Group
                            as={Form.Row}
                            controlId="customer_support_email"
                          >
                            <Form.Label column>
                              Email to Receive Requests from Customers
                            </Form.Label>
                            <Col>
                              <Form.Control
                                name="customer_support_email"
                                value={this.state.customer_support_email}
                                onChange={this.handleInputChange}
                              />
                            </Col>
                          </Form.Group>
                        )}
                      </Col>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-danger"
                  eventKey="2"
                >
                  Price List
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainMerchantPrice">
                        <Form.Label>Merchant Price </Form.Label>
                        <Form.Control
                          value={this.state.merchant_price}
                          onChange={this.handleInputChange}
                          name="merchant_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formExchangePrice">
                        <Form.Label>Exchange Price </Form.Label>
                        <Form.Control
                          value={this.state.exchange_price}
                          onChange={this.handleInputChange}
                          name="exchange_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainAddSTDPrice">
                        <Form.Label>Add STD Item Price</Form.Label>
                        <Form.Control
                          value={this.state.additional_standard_item_price}
                          onChange={this.handleInputChange}
                          name="additional_standard_item_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainWeightThreshold">
                        <Form.Label>Weight Threshold</Form.Label>
                        <Form.Control
                          value={this.state.weight_threshold}
                          onChange={this.handleInputChange}
                          name="weight_threshold"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainOverweightPrice">
                        <Form.Label>Overweight Price</Form.Label>
                        <Form.Control
                          value={this.state.overweight_order_price}
                          onChange={this.handleInputChange}
                          name="overweight_order_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainAddOWPrice">
                        <Form.Label>Add OW Item Price </Form.Label>
                        <Form.Control
                          value={this.state.additional_overweight_item_price}
                          onChange={this.handleInputChange}
                          name="additional_overweight_item_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainShipThreshold">
                        <Form.Label>Free Shipping Threshold</Form.Label>
                        <Form.Control
                          value={this.state.free_shipping_threshold}
                          onChange={this.handleInputChange}
                          name="free_shipping_threshold"
                        />
                      </Form.Group>{" "}
                      <Form.Group as={Col} controlId="formPlainShipCostNotfree">
                        <Form.Label>Shipping Cost If Not Free </Form.Label>
                        <Form.Control
                          value={this.state.shipping_cost_if_not_free}
                          onChange={this.handleInputChange}
                          name="shipping_cost_if_not_free"
                        />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-danger"
                  eventKey="3"
                >
                  Delivery Details
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="3">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainDeliveryTitle">
                        <Form.Label>Delivery Title</Form.Label>
                        <Form.Control
                          value={this.state.delivery_title}
                          onChange={this.handleInputChange}
                          name="delivery_title"
                        />
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        controlId="formPlainDeliveryDescription"
                      >
                        <Form.Label>Delivery Description</Form.Label>
                        <Form.Control
                          value={this.state.delivery_description}
                          onChange={this.handleInputChange}
                          name="delivery_description"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainPickupNotes">
                        <Form.Label>Pick Up Notes</Form.Label>
                        <Form.Control
                          value={this.state.pick_up_notes}
                          onChange={this.handleInputChange}
                          name="pick_up_notes"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainAllowedFsas">
                        <Form.Label>Allowed FSAs</Form.Label>
                        <Form.Control
                          value={this.state.allowed_fsas}
                          onChange={this.handleInputChange}
                          name="allowed_fsas"
                        />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-danger"
                  eventKey="4"
                >
                  Billing Details
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="4">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainBillingContact">
                        <Form.Label>Billing Contact</Form.Label>
                        <Form.Control
                          value={this.state.billing_contact}
                          onChange={this.handleInputChange}
                          name="billing_contact"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainBillingEmail">
                        <Form.Label>Billing Email</Form.Label>
                        <Form.Control
                          value={this.state.billing_email}
                          onChange={this.handleInputChange}
                          name="billing_email"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainPaymentTerms">
                        <Form.Label>Payment Terms</Form.Label>
                        <Form.Control
                          value={this.state.payment_terms}
                          onChange={this.handleInputChange}
                          name="payment_terms"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainPaymentDays">
                        <Form.Label>Payment Days</Form.Label>
                        <Form.Control
                          value={this.state.payment_days}
                          onChange={this.handleInputChange}
                          name="payment_days"
                        />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
            <ButtonGroup aria-label="Basic example">
              <Button type="submit" variant="outline-danger">
                Save Changes
              </Button>
            </ButtonGroup>
          </Form>
          <Link to="/stats">
            <Button variant="outline-secondary">Back to Stakeholders</Button>
          </Link>

          {this.state.showSuccess && (
            <SweetAlert
              type="info"
              title={this.state.message}
              onConfirm={this.props.show}
              showCancel={false}
              confirmBtnText="OK"
              closeAnim={{
                name: "hideSweetAlert",
                duration: 100,
              }}
            />
          )}
        </Fragment>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  editMerchantProfile: (merchant) => dispatch(editMerchantProfile(merchant)),
});
export default withRouter(
  connect(null, mapDispatchToProps)(EditMerchantProfile)
);
